/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconChevronDownRight = createSolidComponent(
  "chevron-down-right",
  "IconChevronDownRight",
  [["path", { d: "M16 8v8h-8" }]]
);

export { IconChevronDownRight as default };
//# sourceMappingURL=IconChevronDownRight.js.map
